import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { textReveal } from './text-reveal';

gsap.registerPlugin(ScrollTrigger);


// Text animation on hero
function animateTextOnHeroBanner(heroBanner) {
  if (!heroBanner) return;

  const title = heroBanner.querySelector('.animate-title');
  const intro = heroBanner.querySelector('.hero-intro');
  const cta = heroBanner.querySelector('.hero-cta');

  const targets = [title, intro, cta].filter(Boolean);

  document.fonts.ready.then(() => {
    // Wait until fonts are loaded, then run animation
    setTimeout(() => {
      if (targets.length) {
        textReveal(title, title, intro, cta, 0, 'by-lines');
      }
    }, 200); // give layout a moment to stabilize
  });
}

// ACHA hero banner animation
function animateHeroBannerAcha() {
  if (!document.body.classList.contains('acha')) return;

  const heroBanner = document.querySelector('.hero-banner');
  if (!heroBanner) return;

  const image = heroBanner.querySelector('.hero-image');

  animateTextOnHeroBanner(heroBanner);

  if (image) {
    gsap.from(image, {
      x: 250,
      opacity: 0,
      scale: 0.3,
      duration: 1.5,
      ease: 'power2.out',
    });
  }
}

// RDN Health hero banner animation
function animateHeroBannerRdn() {
  if (!document.body.classList.contains('rdn')) return;
  
  const heroBanner = document.querySelector('.hero-banner');
  if (!heroBanner) return;

  const rdnImage = heroBanner.querySelector('.hero-image-rdn img');
  if (!rdnImage) return;

  animateTextOnHeroBanner(heroBanner);
  
  window.addEventListener("scroll", () => {
    const scrolled = window.scrollY;
    rdnImage.style.transform = `translate(-50%, ${scrolled * 0.5}px)`; 
  });
}

function animateIntroductoryBlock() {
  const introductoryBlock = document.querySelector('.introductory-block');

  if (!introductoryBlock) return;

  const title = introductoryBlock.querySelector('.ib-info-text h2, .ib-info-text h3');
  const intro = introductoryBlock.querySelectorAll('.ib-info-text p');
  const cta = introductoryBlock.querySelector('.fc-info-cta');

  if (title || intro || cta) {
    textReveal(title, title, intro, cta, 0, 'by-lines');
  }
}

window.addEventListener('DOMContentLoaded', () => {
  animateHeroBannerAcha();
  animateHeroBannerRdn()
  animateIntroductoryBlock();
});